import React from "react";

interface KarigarIconProps {
  size?: number;
  url?: string;
}

const DEFAULT_ICON_URL =
  "https://hastkala.s3.ap-south-1.amazonaws.com/upload-file/main_logo/main_logo_ed5023a8-ec32-46a4-8a40-89a5f52f9f60.JPG";

const KarigarIcon: React.FC<KarigarIconProps> = ({ size = 100, url="" }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        background: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >
      <img
        src={url}
        alt="Karigar Icon"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "50%",
        }}
      />
    </div>
  );
};

export default KarigarIcon;
